import axios from 'axios'

export const DashboardApi = {
  summary: (companyId) => axios.get('/web/dashboard/', {
    params: {
      companyId
    }
  }),
  monthlyInspections: (companyId) => axios.get('/web/dashboard/monthly-inspections/', {
    params: {
      companyId
    }
  }),
  equipmentStatus: (companyId) => axios.get('/web/dashboard/equipment-status/', {
    params: {
      companyId
    }
  }),
  employeeInspections: (dateStart, dateEnd, companyId) => axios.get('/web/dashboard/employee-inspections-by-month/', {
    params: {
      dateStart,
      dateEnd,
      companyId
    }
  }),
  inspectionTypeInspections: (companyId) => axios.get('/web/dashboard/inspection-type-inspections/', {
    params: {
      companyId
    }
  }),
  productInspections: (dateStart, dateEnd, companyId) => axios.get('/web/dashboard/product-inspections-by-month/', {
    params: {
      dateStart,
      dateEnd,
      companyId
    }
  })
}
